import { getApi, getPaginated } from 'util/backendapi/fetch';
import {
  makeReportingDuck,
  ReportingDuckActions,
} from 'ducks/make-reporting-duck';
import { Filter } from 'util/backendapi/models/api.interfaces';
import { AlarmCategory_STATUS } from 'util/backendapi/types/Enum';

export const alarmCategoryListDuck = makeReportingDuck(
  'alarmCategory',
  (filters: Filter.ReportsAlarmCategory) =>
    getPaginated('/reports/alarm-categories/', {
      status: AlarmCategory_STATUS.active,
      ...filters,
    }),
  () => getApi('/reports/alarm-categories/info/')
);

export type AlarmCategoryListActions = ReportingDuckActions<
  typeof alarmCategoryListDuck
>;
